import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'ck-ui';
import classnames from 'classnames';
import styles from './Tag.module.scss';

/**
 * @todo use hook instead of class
 */
class Tag extends Component {
  state = { show: true };

  onClickTag = () => {
    const { type, closable } = this.props;
    if (type === 'button' && closable) {
      this.onClose();
    }
  };

  onClose = () => {
    this.setState({ show: false });
    const { onClose } = this.props;

    if (typeof onClose === 'function') {
      onClose();
    }
  };

  render = () => {
    const { closable, children, className, size, color, type } = this.props;
    const { show } = this.state;

    if (show) {
      return (
        <span
          className={classnames(
            styles.tag,
            className,
            styles[`size-${size}`],
            styles[color],
            type && styles[`type-${type}`],
          )}
          onClick={this.onClickTag}
          role="button"
          tabIndex="0"
        >
          {children}
          {closable ? (
            <Icon
              className={classnames(styles.icon)}
              name="cross"
              onClick={this.onClose}
              size="small"
            />
          ) : null}
        </span>
      );
    }
    return null;
  }
}

Tag.propTypes = {
  closable: PropTypes.bool,
  onClose: PropTypes.func,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(['primary']),
  size: PropTypes.oneOf(['regular']),
  type: PropTypes.oneOf(['label', 'button']),
};

Tag.defaultProps = {
  closable: false,
  onClose: null,
  className: null,
  size: 'regular',
  color: 'primary',
  type: 'label',
};

export { Tag };
